import { getRuntimeConfigList } from '@/modules/datasource-api/collectionAPI';
import { DBSource } from '@/modules/datasource-api/DBSource';
import { HTTPSource } from '@/modules/datasource-api/HTTPSource';
import { checkIsMultiHTTPCollection, isDBLikeDataSource } from '@/modules/datasource-api/utils/tools';
import commonTSDeclaration from '!!raw-loader!../../datasource-api/types/DBSource.d.ts';
import { getValidPascalCase } from '@tencent/data-schema-core/cjs/convertor/typeOptions.js';
import { DATA_SOURCE_TYPE_PREFIX } from '@/modules/datasource-api/utils/const';
export async function getTypeDefinitions(projectId) {
    const allDataSources = await getRuntimeConfigList({
        projectId,
    });
    let hasDBDataSource = false;
    const typePrefix = DATA_SOURCE_TYPE_PREFIX;
    const dts = `declare module "@wujibase/wuji-data" {
${allDataSources.map(source => `  export const ${source.collectionId}: ${getValidPascalCase(`${typePrefix}-${source.collectionId}`)};`).join('\n')}
  export type { ${allDataSources.map(source => getValidPascalCase(`${typePrefix}-${source.collectionId}`)).join(', ')} }
}
${await Promise.all(allDataSources.map(async (source) => {
        const { collectionId } = source;
        let dataSource;
        if (isDBLikeDataSource(source)) {
            hasDBDataSource = true;
            dataSource = new DBSource({
                collectionId,
                projectId,
            });
        }
        else {
            if (checkIsMultiHTTPCollection(source)) {
                hasDBDataSource = true;
            }
            dataSource = new HTTPSource({
                collectionId,
                projectId,
            });
        }
        return await dataSource.getTSDeclaration({ source, withCommon: false });
    })).then(results => results.join('\n'))}
  ${hasDBDataSource ? commonTSDeclaration : ''}
`;
    return dts;
}
export default class WujiData {
    data;
    static async create(projectId) {
        const data = await this.getDataObject(projectId);
        return new WujiData(data);
    }
    static async getDataObject(projectId) {
        const allDataSources = await getRuntimeConfigList({
            projectId,
        });
        const dataObject = {};
        await Promise.all(allDataSources.map(async (source) => {
            const { collectionId } = source;
            let dataSource;
            if (isDBLikeDataSource(source)) {
                dataSource = new DBSource({
                    collectionId,
                    projectId,
                });
            }
            else {
                dataSource = new HTTPSource({
                    collectionId,
                    projectId,
                });
            }
            dataObject[collectionId] = await dataSource.getMethods({ source });
        }));
        return dataObject;
    }
    constructor(data) {
        this.data = data;
    }
    getData() {
        return this.data;
    }
}
